export default __webpack_public_path__ + "static/media/quiz-pic-5.f493cd03.jpeg";